import jwtAuthAxios from "../../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';


export const findByPeriode = createAsyncThunk("reportDaftarUlang/findByPeriode", async (val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/report/registrasi/ulang`, val);
    return response.data;
});

export const findByPeriodePendaftaran = createAsyncThunk("reportDaftarUlang/findByPeriodePendaftaran", async (val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/report/pendaftaran`, val);
    return response.data;
});

// --- Daftar ulang (sudah daftar ulang) : server-side paged + filtered download ---
export const searchRegistrasiUlang = createAsyncThunk("reportDaftarUlang/searchRegistrasiUlang", async (val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/report/registrasi/ulang/search`, val);
    return response.data;
});
export const downloadRegistrasiUlang = createAsyncThunk("reportDaftarUlang/downloadRegistrasiUlang", async (val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/report/registrasi/ulang/download`, val);
    return response.data;
});

// --- Belum daftar ulang (data pendaftaran) : server-side paged + filtered download ---
export const searchPendaftaran = createAsyncThunk("reportDaftarUlang/searchPendaftaran", async (val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/report/pendaftaran/search`, val);
    return response.data;
});
export const downloadPendaftaran = createAsyncThunk("reportDaftarUlang/downloadPendaftaran", async (val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/report/pendaftaran/download`, val);
    return response.data;
});

const emptyPaged = { content: [], totalElements: 0, totalPages: 0, page: 0, size: 10 };

const initialState = {
    dataPeriode: [],
    dataPendaftaran: [],
    dataPeriodeLoading: false,
    findByPeriodePendaftaran: false,
    registrasiUlangPaged: { ...emptyPaged },
    registrasiUlangLoading: false,
    pendaftaranPaged: { ...emptyPaged },
    pendaftaranPagedLoading: false,
    downloadLoading: false,
}

const reportDaftarUlangSlice = createSlice({
    name: "reportDaftarUlang",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(findByPeriode.pending, (state, action) => {
                state.dataPeriodeLoading = true
            })
            .addCase(findByPeriode.fulfilled, (state, action) => {
                state.dataPeriode = action.payload
                state.dataPeriodeLoading = false
            })
            .addCase(findByPeriode.rejected, (state, action) => {
                state.dataPeriodeLoading = false
                state.editPayError = action.error
            })
        builder
            .addCase(findByPeriodePendaftaran.pending, (state, action) => {
                state.dataPendaftaranLoading = true
            })
            .addCase(findByPeriodePendaftaran.fulfilled, (state, action) => {
                state.dataPendaftaran = action.payload
                state.dataPendaftaranLoading = false
            })
            .addCase(findByPeriodePendaftaran.rejected, (state, action) => {
                state.dataPendaftaranLoading = false
                state.editPayError = action.error
            })
        builder
            .addCase(searchRegistrasiUlang.pending, (state) => {
                state.registrasiUlangLoading = true
            })
            .addCase(searchRegistrasiUlang.fulfilled, (state, action) => {
                state.registrasiUlangPaged = action.payload
                state.registrasiUlangLoading = false
            })
            .addCase(searchRegistrasiUlang.rejected, (state) => {
                state.registrasiUlangLoading = false
            })
        builder
            .addCase(searchPendaftaran.pending, (state) => {
                state.pendaftaranPagedLoading = true
            })
            .addCase(searchPendaftaran.fulfilled, (state, action) => {
                state.pendaftaranPaged = action.payload
                state.pendaftaranPagedLoading = false
            })
            .addCase(searchPendaftaran.rejected, (state) => {
                state.pendaftaranPagedLoading = false
            })
        builder
            .addCase(downloadRegistrasiUlang.pending, (state) => { state.downloadLoading = true })
            .addCase(downloadRegistrasiUlang.fulfilled, (state) => { state.downloadLoading = false })
            .addCase(downloadRegistrasiUlang.rejected, (state) => { state.downloadLoading = false })
            .addCase(downloadPendaftaran.pending, (state) => { state.downloadLoading = true })
            .addCase(downloadPendaftaran.fulfilled, (state) => { state.downloadLoading = false })
            .addCase(downloadPendaftaran.rejected, (state) => { state.downloadLoading = false })
    }
});

export const reportDaftarUlangSelectors = (state) => state.reportDaftarUlang;
export default reportDaftarUlangSlice.reducer;
